import { Component, OnInit } from '@angular/core';
import { DataTable, DataTableResource, DataTableTranslations } from 'angular7-data-table';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModalRef, NgbModalOptions, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { PartnerService } from "../partner.service"
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
import { ConfirmationComponent } from 'src/app/common/components/confirmation/confirmation.component';
import { ExcelService } from '../../dashboard/excel.service';
import * as moment from 'moment';

@Component({
  selector: 'app-view-partner',
  templateUrl: './view-partner.component.html',
  styleUrls: ['./view-partner.component.css']
})

export class ViewPartnerComponent implements OnInit {

  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,

  };
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "blocked", name: "Blocked" }
  ];
  closeResult: string;
  statusFormSubmitted: boolean = false;
  planDetails: any;
  statusForm: FormGroup;
  featureList = [];
  finalFeatureList = [];
  coursePlanList = [];
  temp: any;
  feature: string;
  plancount: number;
  plan_id: any;

  constructor(private formBuilder: FormBuilder, 
    private modalService: NgbModal, 
    private PlanService: PartnerService, 
    private spinner: NgxSpinnerService,
    private ExcelService: ExcelService) { }

  ngOnInit() {
    this.spinner.show();

    this.getplan();
    // this.startLoadingSpinner();
  }

  startLoadingSpinner() {

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 3000);
  }

  labels = <DataTableTranslations>{
    loadingText: 'Your {title} table is reloading - and this is my custom message.',
    paginationText: 'Your table displays {from} to {to} of {total} rows.'
  };
  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }
  getplan() {
    this.PlanService.getplanList().subscribe(res => {
      this.spinner.show();
      if ((res["status"] = "Success")) {
        this.coursePlanList = res.data.partnerList;
        this.plancount = this.coursePlanList.length
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }



  updateUserStatus(test) {
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.spinner.show();
      let finalObj = {
        coursePlanId: this.planDetails["coursePlanId"],
        status: this.statusForm.controls.newStatus.value
      };
      this.PlanService.Editplan(finalObj).subscribe(data => {
        this.spinner.hide();

        if ((data["message"] = "Success")) {
          Swal.fire("Success", "User status updated successfully!", "success");
          this.modalRef.close();
          this.getplan();
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
  }


  updateUserStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.planDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  updateUserStatusModal1(row, content, btn) {

    this.plan_id = row.partnerId;
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.planDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  confirmDeleteRecord(record: any) {

    let modalRef = this.modalService.open(ConfirmationComponent, this.modelOptions);
    modalRef.componentInstance.content = "Are you sure you want to delete this record?";
    modalRef.componentInstance.leftButton = "No";
    modalRef.componentInstance.rightButton = "Yes";
    modalRef.result.then(
      (data: any) => {
        if (data == "yes") {
          this.deleteRecord(record);
        }
      },
      (reason: any) => { }
    );
  }

  deleteStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();


    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }


  deleteRecord(record: any) {

    this.spinner.show();

    this.PlanService.deleteplan(this.plan_id).subscribe(res => {
      if ((res["status"] = "Success")) {
        Swal.fire("Success", "Partner Deleted successfully!", "success");
        this.modalRef.close();
        this.spinner.hide();
        this.getplan();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }
  downloadList:any;
  inviteCode:string;
 

  DownloadUser(data){
    this.downloadList = [];
    if (data.totalUsers == 0) {
      return
    }
    let query = 'inviteCode='+data.inviteCode+"&limit="+data.totalUsers;
    this.inviteCode = data.inviteCode;
    this.PlanService.getUserList(query).subscribe(res => {
      if ((res["message"] == "Success")) {
     let tempList=res.data.userList;
      tempList.forEach(element => {
        let Obj={
          firstName:element['firstName'] || 'NA',
          lastName:element['lastName'] || 'NA',
          userName:element['userName'] || 'NA',
          mobile:element['mobile'] || 'NA',
          email:element['email'] || 'NA',
          dob:element['dob'] ,
          gender:element['gender'],
          userType:element['userType'],
          hasActivePlan:element['hasActivePlan'],
          courseName:element['courseData']['currentCourseTitle'],
          courseWeek:element['courseData']['currentWeek'],
          insertDate: moment.unix(element['creationDate']).format("MM/DD/YYYY"),
        }
        if (element['onTrailPlan'] == true){
          Obj["subscriptionStatus"] = element['subscriptionStatus'] + ' (Trial)';
        }
        else {
          Obj["subscriptionStatus"] = element['subscriptionStatus'] ;
        }
        if( element['subscriptionData'] ){
          Obj["nextDueDate"]=moment.unix(element['subscriptionData']['0']['nextDueDate']).format("MM/DD/YYYY") || 'NA';;
          Obj["SubscriptionAmount"]=element['subscriptionData']['0']['subscriptionAmount'];
            if(element['subscriptionData']['0']['lastPaymentDate']){
              Obj["lastPaymentDate"]= moment.unix(element['subscriptionData']['0']['lastPaymentDate']).format("MM/DD/YYYY") || 'NA';
            }
          Obj["lastSubscriptionAmount"]=element['subscriptionData']['0']['lastSubscriptionAmount'] ;
        }
        if(element['hasActivePlan']==false && element['subscriptionStatus'] !=='canceled' && element['subscriptionStatus'] !=='active'  ){
          Obj['UserStatus']='Trail'
        }else{
          Obj['UserStatus']=element['status']
        }
      this.downloadList.push(Obj)
      
      });
      this.exportAsXLSX();
      } else {
      }
    });

  }
  SetDownloadSummary() {
    this.downloadList.forEach(element => {
      if( element['courseData']) {
        delete element['courseData'];
      }
      if (element['subscriptionData']) {
        delete element['subscriptionData'];
      }
      if (element['profilePic']) {
        delete element['profilePic'];
      }
      element['creationDate'] = moment.unix(element['creationDate']).format('dddd, MMMM Do, YYYY h:mm:ss A');
      
      if(element['trailEndDate']) {
      element['trailEndDate'] = moment.unix(element['trailEndDate']).format('dddd, MMMM Do, YYYY h:mm:ss A');
      }
      if(element['vitalModifyDate']) {
        element['vitalModifyDate'] = moment.unix(element['vitalModifyDate']).format('dddd, MMMM Do, YYYY h:mm:ss A');
      }
      

    });
    this.exportAsXLSX();
  }
  exportAsXLSX(): void {
    var todayTime = new Date();
    let currentTimeEpoch = Date.now();
    let date = new Date(currentTimeEpoch);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();

    this.ExcelService.exportAsExcelFile(this.downloadList,"Partner_"+ this.inviteCode+'_' + month + "/" + day + "/" + year);
  }
}
